module.exports = __webpack_public_path__ + "static/media/aqua-les.22e20b11.png";